import { historyAdapter } from './historyAdapter'
import { historyApi } from './historyApi'
import { CryptoHistoryPriceParams, CryptoHistoryPriceDTO } from './historyTypes'

async function fetchCryptoPriceHistory(
  params: CryptoHistoryPriceParams,
): Promise<{ data: CryptoHistoryPriceDTO[] }> {
  const data = await historyApi.fetchCryptoPriceHistory(params)

  return historyAdapter.adapterCurrencyPriceHistory({
    data: data?.data || [],
    period: params.period,
  })
}

export const historyServices = {
  fetchCryptoPriceHistory,
}
